import React, { useState, useEffect } from 'react';
import './VerificarAfiliado.css';
import baseURL from '../../Components/url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faIdCard,
    faGlobeAmericas,
    faSearch,
    faSpinner,
    faCheckCircle,
    faExclamationCircle,
    faUserCheck,
    faUserPlus,
    faShieldAlt,
    faGift,
    faAward,
    faArrowRight
} from '@fortawesome/free-solid-svg-icons';

const PAISES = [
    { code: 'PE', name: 'Perú', flag: '🇵🇪' },
    { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
    { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
    { code: 'MX', name: 'México', flag: '🇲🇽' },
    { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
    { code: 'CL', name: 'Chile', flag: '🇨🇱' },
    { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
    { code: 'PA', name: 'Panamá', flag: '🇵🇦' },
    { code: 'US', name: 'Estados Unidos', flag: '🇺🇸' },
    { code: 'ES', name: 'España', flag: '🇪🇸' },
    { code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
    { code: 'BR', name: 'Brasil', flag: '🇧🇷' },
];

export default function VerificarAfiliado() {
    const [dni, setDni] = useState('');
    const [pais, setPais] = useState('PE');
    const [loading, setLoading] = useState(false);
    const [resultado, setResultado] = useState(null);
    const [errorMsg, setErrorMsg] = useState('');
    const [contacto, setContacto] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        // Cargar teléfono de contacto para el enlace de WhatsApp
        fetch(`${baseURL}/contactoGet.php`)
            .then(res => res.json())
            .then(data => {
                const list = data.contacto || [];
                setContacto(list[0] || {});
            })
            .catch(err => console.error('Error al cargar contacto:', err));
    }, []);

    const handleVerificar = async (e) => {
        e.preventDefault();
        const docLimpio = dni.trim();
        if (!docLimpio) {
            setErrorMsg('Por favor ingrese su número de DNI o documento.');
            return;
        }

        setErrorMsg('');
        setResultado(null);
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('dni', docLimpio);
            formData.append('pais', pais);

            const response = await fetch(`${baseURL}/verificarAfiliado.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (!data.success && data.message && !data.detalles) {
                setErrorMsg(data.message);
            } else {
                setResultado(data);
            }
        } catch (err) {
            console.error('Error al consultar verificación:', err);
            setErrorMsg('No se pudo establecer conexión con el servidor. Intente de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    const telefonoLimpio = (contacto.telefono || '').replace(/\D/g, '');
    const paisSeleccionado = PAISES.find(p => p.code === pais) || { name: pais, flag: '🌐' };

    const getWhatsAppLink = (tipo) => {
        let msg = '';
        if (tipo === 'afiliar') {
            msg = `Hola, realicé la consulta de mi documento (${dni}) en la web y NO me encuentro afiliado a DXN en ${paisSeleccionado.name}. Deseo afiliarme ahora.`;
        } else {
            msg = `Hola, consulté mi documento (${dni}) y ya cuento con código DXN. Quisiera mayor información sobre pedidos y productos.`;
        }
        return `https://api.whatsapp.com/send?phone=${telefonoLimpio}&text=${encodeURIComponent(msg)}`;
    };

    return (
        <div className="verificar-page-wrapper">
            <div className="verificar-afiliado-page">
                {/* Hero / Header Section */}
                <div className="verificar-hero">

                <h1>¿Estás Afiliado a DXN?</h1>
                <p>
                    Ingresa tu número de documento de identidad y selecciona tu país para consultar en tiempo real
                    si ya cuentas con un código de membresía registrado en la red mundial de DXN.
                </p>
            </div>

            {/* Verification Form Card */}
            <div className="verificar-card-container">
                <div className="verificar-card">
                    <form onSubmit={handleVerificar} className="verificar-form">
                        <div className="form-group-grid">
                            {/* Combo Selección de País */}
                            <div className="form-group">
                                <label htmlFor="pais-select">
                                    <FontAwesomeIcon icon={faGlobeAmericas} className="input-icon" /> Selecciona tu País:
                                </label>
                                <div className="select-wrapper">
                                    <select
                                        id="pais-select"
                                        value={pais}
                                        onChange={(e) => setPais(e.target.value)}
                                        className="form-control"
                                    >
                                        {PAISES.map((p) => (
                                            <option key={p.code} value={p.code}>
                                                {p.flag} {p.name} ({p.code})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Input DNI / Documento */}
                            <div className="form-group">
                                <label htmlFor="dni-input">
                                    <FontAwesomeIcon icon={faIdCard} className="input-icon" /> Número de DNI / Documento:
                                </label>
                                <input
                                    id="dni-input"
                                    type="text"
                                    placeholder="Ej: 12345678"
                                    value={dni}
                                    onChange={(e) => setDni(e.target.value)}
                                    className="form-control"
                                    maxLength={20}
                                    required
                                />
                            </div>
                        </div>

                        {errorMsg && (
                            <div className="alert-box alert-error">
                                <FontAwesomeIcon icon={faExclamationCircle} /> {errorMsg}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn-verificar"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Verificando en DXN...
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faSearch} /> Verificar Estado
                                </>
                            )}
                        </button>
                    </form>

                    {/* Results Container */}
                    {resultado && (
                        <div className="resultado-wrap">
                            {resultado.afiliado ? (
                                /* Documento YA Registrado */
                                <div className="resultado-card afiliado-si">
                                    <div className="resultado-icon-wrap icon-warning">
                                        <FontAwesomeIcon icon={faUserCheck} />
                                    </div>
                                    <div className="resultado-content">
                                        <h3>¡Ya eres Miembro de DXN!</h3>
                                        <p className="resultado-desc">
                                            El documento <strong>{resultado.dni}</strong> registrado en{' '}
                                            <strong>{paisSeleccionado.name}</strong> ya cuenta con código activo de afiliado DXN.
                                        </p>
                                        <div className="resultado-details">
                                            <p>
                                                Si necesitas reactivar tu código, conocer tu puntaje (PV), o realizar pedidos con entrega inmediata, estamos para apoyarte.
                                            </p>
                                        </div>
                                        {telefonoLimpio && (
                                            <a
                                                href={getWhatsAppLink('asistencia')}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn-accion-whatsapp whatsapp-outline"
                                            >
                                                <i className="fa fa-whatsapp"></i> Contactar para Asistencia de Miembro
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                /* Documento NO Registrado -> Invitación a Afiliarse */
                                <div className="resultado-card afiliado-no">
                                    <div className="resultado-icon-wrap icon-success">
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                    </div>
                                    <div className="resultado-content">
                                        <div className="disponible-badge">¡Disponible para Registro!</div>
                                        <h3>Este documento NO está registrado en DXN</h3>
                                        <p className="resultado-desc">
                                            El documento <strong>{resultado.dni}</strong> está totalmente libre para afiliarse.
                                            ¡Puedes empezar hoy mismo y aprovechar todos los beneficios y precios especiales de distribuidor!
                                        </p>

                                        <div className="afiliacion-cta-box">
                                            <h4>¿Por qué afiliarte hoy con nosotros?</h4>
                                            <ul>
                                                <li>Descuentos inmediatos de hasta el 40% - 50% en toda la línea de productos.</li>
                                                <li>Código internacional vitalicio y heredable (válido en más de 180 países).</li>
                                                <li>Capacitación gratuita sobre Ganoterapia y salud holística.</li>
                                            </ul>

                                            {telefonoLimpio && (
                                                <a
                                                    href={getWhatsAppLink('afiliar')}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn-accion-whatsapp whatsapp-fill"
                                                >
                                                    <FontAwesomeIcon icon={faUserPlus} /> ¡Afiliarme Ahora a DXN por WhatsApp!
                                                    <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: 8 }} />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
    );
}
